export default __webpack_public_path__ + "static/media/missao.570efd37.png";